import { useCallback } from 'react';
import { selectFeatureFlags, selectModalSessionId, } from '../state/slices/slice-link-params';
import { noop } from '../utils/index';
import { useAppSelector } from '../state/index';
export default function useFireClientEvent() {
    var modalSessionId = useAppSelector(selectModalSessionId);
    var featureFlags = useAppSelector(selectFeatureFlags);
    var fireClientEvent = (window.clientEmitters && window.clientEmitters[modalSessionId]) || noop;
    var wrappedWithFeatureFlagChecks = useCallback(function (eventName, payload) {
        if (eventName === 'input_required' &&
            !featureFlags.inputRequiredEventEnabled) {
            return;
        }
        fireClientEvent(eventName, payload);
    }, [fireClientEvent, featureFlags.inputRequiredEventEnabled]);
    return wrappedWithFeatureFlagChecks;
}
